import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

export const StationSpecs = (props) => {

    const { t, i18n } = useTranslation();

    const size_range = {
        "Small": [0, 60],
        "Medium": [60, 250],
        "Large": [250, 9e9],
    };
    
    let size;
    if(
        props.data["S"] > size_range["Small"][0] && 
        props.data["S"] < size_range["Small"][1]
    )
        size = "size-small";
    else if(
        props.data["S"] > size_range["Medium"][0] && 
        props.data["S"] < size_range["Medium"][1]
    )
        size = "size-med";
    else if(
        props.data["S"] > size_range["Large"][0] && 
        props.data["S"] < size_range["Large"][1]
    )
        size = "size-large";

    return (
        <tbody>
            {"AP" in props.data && (
                <tr>
                    <td>{t('filters-stations.applications')}</td>
                    <td>{props.data["AP"].map((application) => t('application.' + application)).join(", ")}</td>
                </tr>
            )}
            {"T" in props.data && (
                <tr>
                    <td>{t('filters-stations.tags')}</td>
                    <td>{props.data["T"].map((tag) => t('tags-station.' + tag)).join(", ")}</td>
                </tr>
            )}
            {"B" in props.data && (
                <tr>
                    <td>{t('filters-stations.brand')}</td>
                    <td>{props.data["B"].join(", ")}</td>
                </tr>
            )}
            {"RT" in props.data && (
                <tr>
                    <td>{t('filters-stations.robot-types')}</td>
                    <td>{props.data["RT"].map((rt) => t('item-types.' + rt)).join(", ")}</td>
                </tr>
            )}
            {"RN" in props.data && (
                <tr>
                    <td>{t('filters-stations.robot-names')}</td>
                    <td>{props.data["RN"].join(", ")}</td>
                </tr>
            )}
            {"AN" in props.data && (
                <tr>
                    <td>{t('filters-stations.axes-names')}</td>
                    <td>{props.data["AN"].join(", ")}</td>
                </tr>
            )}
            {"MN" in props.data && (
                <tr>
                    <td>{t('filters-stations.mechanism-count')}</td>
                    <td>{props.data["MN"].join(", ")}</td>
                </tr>
            )}
            {"TN" in props.data && (
                <tr>
                    <td>{t('filters-stations.tool-names')}</td>
                    <td>{props.data["TN"].join(", ")}</td>
                </tr>
            )}
            {"ON" in props.data && (
                <tr>
                    <td>{t('filters-stations.object-names')}</td>
                    <td>{props.data["ON"].join(", ")}</td>
                </tr>
            )}
            {"RC" in props.data && props.data["RC"] > 1 && (
                <tr>
                    <td>{t('filters-stations.robot-count')}</td>
                    <td>{props.data["RC"]}</td>
                </tr>
            )}
            {"TC" in props.data && props.data["TC"] > 1 && (
                <tr>
                    <td>{t('filters-stations.tool-count')}</td>
                    <td>{props.data["TC"]}</td>
                </tr>
            )}
            {"OC" in props.data && props.data["OC"] > 3 && (
                <tr>
                    <td>{t('filters-stations.object-count')}</td>
                    <td>{props.data["OC"]}</td>
                </tr>
            )}
            {"S" in props.data && (
                <tr>
                    <td>{t('filters-stations.size')}</td>
                    <td>{t('filters-stations.' + size)}</td>
                </tr>
            )}
        </tbody>
    )
}